import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data";
import { Logo } from "@/components/Header";
import { useEnquiryForm } from "@/context/FormContext";

const LEGAL = [
  { label: "Terms of Use", slug: "terms" },
  { label: "Privacy Notice", slug: "privacy" },
  { label: "Funding Disclaimer", slug: "funding-disclaimer" },
  { label: "Financial-Product Disclaimer", slug: "financial-disclaimer" },
  { label: "Partner Disclosure", slug: "partner-disclosure" },
  { label: "Cookie Notice", slug: "cookie-notice" },
];

export default function Footer() {
  const { openForm } = useEnquiryForm();
  const col = "flex flex-col gap-2.5";
  const link = "text-sm text-zinc-500 hover:text-white transition-colors text-left";
  return (
    <footer className="relative border-t border-white/10 bg-[#050507]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className={col}>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 mb-2">FundAI</span>
            <a href="/#about" className={link}>About</a>
            <a href="/#founders" className={link}>For Founders</a>
            <a href="/#build-scale" className={link}>Build &amp; Scale</a>
            <Link to="/academy" className={link} data-testid="footer-academy-link">Academy</Link>
            <button onClick={() => openForm("founder")} className={link}>Apply for Funding</button>
            <a href="/#contact" className={link}>Contact</a>
          </div>
          <div className={col}>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 mb-2">Investment Access</span>
            {["AIF", "PMS", "Mutual Funds", "Bonds", "Fixed Income", "Insurance"].map((x) => (
              <button key={x} onClick={() => openForm("investment")} className={link}>{x}</button>
            ))}
          </div>
          <div className={col}>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 mb-2">Strategic Network</span>
            {["Technology Partners", "Marketing Partners", "Manufacturing Partners", "Capital Partners", "Professional Partners"].map((x) => (
              <button key={x} onClick={() => openForm("partner")} className={link}>{x}</button>
            ))}
          </div>
          <div className={col}>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 mb-2">Legal</span>
            {LEGAL.map((l) => <Link key={l.slug} to={`/legal/${l.slug}`} className={link} data-testid={`footer-legal-${l.slug}`}>{l.label}</Link>)}
            <button onClick={() => openForm("grievance")} className={link}>Grievance &amp; Data-Rights Request</button>
          </div>
        </div>

        <div className="mt-14 pt-10 border-t border-white/10 grid lg:grid-cols-[1fr_auto] gap-8">
          <div>
            <Logo subtitle={false} />
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-md">
              FundAI is a brand of<br /><span className="text-zinc-300">{BRAND.owner}</span>
            </p>
          </div>
          <div className="font-mono text-xs text-zinc-600 space-y-1 lg:text-right">
            <div>CIN: <span className="text-zinc-400">{BRAND.cin}</span></div>
            <div>GSTIN: <span className="text-zinc-400">{BRAND.gstin}</span></div>
            <div className="pt-2 text-zinc-500 leading-relaxed font-body max-w-xs lg:ml-auto">{BRAND.arn}</div>
            <div className="pt-2">Corporate: <a href={BRAND.corporateSite} target="_blank" rel="noreferrer" className="text-[#00D1FF] hover:underline">nxcore.in</a></div>
            <div className="pt-1 text-zinc-500">Enquiries: submit the appropriate website form.</div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-zinc-600">
          <span>© {new Date().getFullYear()} Nexcore Ventures Private Limited. All rights reserved.</span>
          <span>Mutual Fund investments are subject to market risks. Read all scheme-related documents carefully.</span>
        </div>
      </div>
    </footer>
  );
}
